import React, { useState, useEffect, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import { MenuItem, Select, FormControl, InputLabel, Box, AppBar, Card, CardContent, Chip, Typography as TypographyV5 } from '@mui/material';
import { createTheme as createMuiTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { createTheme as createCoreTheme, ThemeProvider as CoreThemeProvider } from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { useDropzone } from 'react-dropzone';
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { useHistory, useLocation } from "react-router-dom";
import Autocomplete from '@material-ui/lab/Autocomplete';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';

import ListAltIcon from '@mui/icons-material/ListAlt';
import AssignmentIcon from '@mui/icons-material/Assignment';
import DescriptionIcon from '@mui/icons-material/Description';
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import EngineeringIcon from '@mui/icons-material/Engineering';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import NotesIcon from '@mui/icons-material/Notes';

import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import miniatura_pdf from '../../../../../assets/imgs/miniatura_pdf.png';


const drawerWidth = 240;


const dropzoneStyles = {
    border: '2px dashed #cccccc',
    borderRadius: '4px',
    padding: '20px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '20px 0',
};


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
}));



export default function CadastrarOrdemDeServico() {


    const [value, setValue] = React.useState(0);

    const handleChangeTab = (event, newValue) => {
        setValue(newValue);

    }


    const handleChangeIndex = (index) => {
        setValue(index);
    };

    const classes = useStyles();
    const history = useHistory();

    const [darkMode, setDarkMode] = useState(() => {
        const saved = Cookies.get('darkMode') || Cookies.get('tema');
        return saved === 'true' || saved === 'dark';
    });

    const themeHelper = React.useMemo(() => ({
        bg: darkMode ? "#1e1e1e" : "#e9eff3", // Background mais profundo mas menos agressivo que preto puro
        paper: darkMode ? "#2d2d2d" : "#ffffff", // Paper um pouco mais claro que o bg
        text: darkMode ? "#e0e0e0" : "#1a1a1a", // Texto cinza claro em vez de branco puro
        textSecondary: darkMode ? "#b0b0b0" : "#5a6a7a",
        border: darkMode ? "#444444" : "#d1d9e0",
        primary: darkMode ? '#90caf9' : '#1976d2', // Azul mais suave para dark mode
    }), [darkMode]);

    useEffect(() => {
        const checkDarkMode = () => {
            const saved = Cookies.get('darkMode') || Cookies.get('tema');
            setDarkMode(saved === 'true' || saved === 'dark');
        };

        window.addEventListener('temaChanged', checkDarkMode);
        window.addEventListener('darkModeChanged', checkDarkMode);
        window.addEventListener('focus', checkDarkMode);

        const intervalId = setInterval(checkDarkMode, 1000);

        return () => {
            window.removeEventListener('temaChanged', checkDarkMode);
            window.removeEventListener('darkModeChanged', checkDarkMode);
            window.removeEventListener('focus', checkDarkMode);
            clearInterval(intervalId);
        };
    }, []);

    const muiTheme = React.useMemo(() => createMuiTheme({
        palette: {
            mode: darkMode ? 'dark' : 'light',
            primary: { main: themeHelper.primary },
            background: { default: darkMode ? '#121212' : '#ffffff', paper: themeHelper.paper },
            text: { primary: themeHelper.text, secondary: themeHelper.textSecondary },
        },
        components: {
            MuiTextField: {
                styleOverrides: {
                    root: {
                        '& label': { color: darkMode ? '#b0b0b0' : 'inherit' },
                        '& label.Mui-focused': { color: darkMode ? themeHelper.primary : 'inherit' },
                        '& .MuiInput-underline:before': { borderBottomColor: darkMode ? '#444444' : 'inherit' },
                        '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: darkMode ? '#666666' : 'inherit' },
                        '& .MuiInput-underline:after': { borderBottomColor: darkMode ? themeHelper.primary : 'inherit' },
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: darkMode ? '#444444' : 'inherit' },
                            '&:hover fieldset': { borderColor: darkMode ? '#666666' : 'inherit' },
                            '&.Mui-focused fieldset': { borderColor: darkMode ? themeHelper.primary : 'inherit' },
                        },
                        '& .MuiInputBase-input': { color: darkMode ? '#e0e0e0' : 'inherit' },
                    },
                }
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        color: darkMode ? '#b0b0b0' : 'inherit',
                        '&.Mui-focused': { color: darkMode ? themeHelper.primary : 'inherit' },
                    }
                }
            },
            MuiSelect: {
                styleOverrides: {
                    icon: { color: darkMode ? '#ffffff' : 'inherit' },
                    select: { color: darkMode ? '#ffffff' : 'inherit' },
                }
            },
            MuiAutocomplete: {
                styleOverrides: {
                    popupIndicator: { color: darkMode ? '#ffffff' : 'inherit' },
                    clearIndicator: { color: darkMode ? '#ffffff' : 'inherit' },
                }
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        // Se for primary/secondary e NÃO tiver cor explícita, podemos ajustar se necessário,
                        // mas o tema default do MUI v5 já lida bem com modos light/dark se as cores de contraste estiverem certas.
                    },
                    containedPrimary: {
                        color: darkMode ? '#ffffff' : 'inherit',
                    }
                }
            },
            MuiSvgIcon: {
                styleOverrides: {
                    root: {
                        // Ícones sem cor explícita herdam 'inherit' ou 'action', vamos garantir visibilidade.
                    }
                }
            }
        }
    }), [darkMode, themeHelper]);

    const coreTheme = React.useMemo(() => createCoreTheme({
        palette: {
            type: darkMode ? 'dark' : 'light',
            primary: { main: themeHelper.primary },
            background: { default: darkMode ? '#121212' : '#ffffff', paper: themeHelper.paper },
            text: { primary: darkMode ? '#ffffff' : '#000000', secondary: darkMode ? '#aaaaaa' : '#666666' }
        },
        overrides: {
            MuiTextField: {
                root: {
                    '& label': { color: darkMode ? '#b0b0b0' : 'inherit' },
                    '& label.Mui-focused': { color: darkMode ? themeHelper.primary : 'inherit' },
                    '& .MuiInput-underline:before': { borderBottomColor: darkMode ? '#444444' : 'inherit' },
                    '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: darkMode ? '#666666' : 'inherit' },
                    '& .MuiInput-underline:after': { borderBottomColor: darkMode ? themeHelper.primary : 'inherit' },
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: darkMode ? '#444444' : 'inherit' },
                        '&:hover fieldset': { borderColor: darkMode ? '#666666' : 'inherit' },
                        '&.Mui-focused fieldset': { borderColor: darkMode ? themeHelper.primary : 'inherit' },
                    },
                    '& .MuiInputBase-input': { color: darkMode ? '#e0e0e0' : 'inherit' },
                },
            },
            MuiFormLabel: {
                root: {
                    color: darkMode ? '#b0b0b0 !important' : 'inherit',
                    '&$focused': { color: darkMode ? themeHelper.primary + ' !important' : 'inherit' }
                }
            },
            MuiInputBase: {
                input: { color: darkMode ? '#e0e0e0' : 'inherit' },
                root: {
                    '& .MuiSvgIcon-root': { color: darkMode ? '#b0b0b0' : 'inherit' }
                }
            },
            MuiSelect: {
                icon: { color: darkMode ? '#ffffff' : 'inherit' }
            },
            MuiPaper: {
                root: { backgroundColor: themeHelper.paper, color: themeHelper.text }
            },
            MuiIconButton: {
                root: { color: darkMode ? '#ffffff' : 'inherit' }
            },
            MuiTypography: {
                root: { color: themeHelper.text }
            }
        }
    }), [darkMode, themeHelper]);

    const [descricao, setDescricao] = useState('');

    const [loading, setLoading] = useState(true);

    const [logado, setLogado] = useState(null);


    const [descricaoImagem1, setDescricaoImagem1] = useState('');
    const [descricaoImagem2, setDescricaoImagem2] = useState('');
    const [descricaoImagem3, setDescricaoImagem3] = useState('');
    const [descricaoImagem4, setDescricaoImagem4] = useState('');


    const [descricaoVideo1, setDescricaoVideo1] = useState('');
    const [descricaoVideo2, setDescricaoVideo2] = useState('');
    const [descricaoVideo3, setDescricaoVideo3] = useState('');


    const [descricaoArquivo1, setDescricaoArquivo1] = useState('');
    const [descricaoArquivo2, setDescricaoArquivo2] = useState('');
    const [descricaoArquivo3, setDescricaoArquivo3] = useState('');

    const [imagemSelecionada1, setImagemSelecionada1] = useState(null);
    const [imagemSelecionada2, setImagemSelecionada2] = useState(null);
    const [imagemSelecionada3, setImagemSelecionada3] = useState(null);
    const [imagemSelecionada4, setImagemSelecionada4] = useState(null);

    const onDrop1 = useCallback((acceptedFiles) => {
        // Obtém o arquivo recebido
        const file = acceptedFiles[0];
        if (!file) {
            alert("Nenhum arquivo recebido.");
            return;
        }

        // Converte a imagem para PNG usando Canvas
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = img.width;
                canvas.height = img.height;

                // Desenha a imagem no Canvas
                ctx.drawImage(img, 0, 0);

                // Converte o Canvas para PNG
                canvas.toBlob(
                    (blob) => {
                        const convertedFile = new File([blob], `${file.name.split('.')[0]}.png`, { type: "image/png" });
                        setImagemSelecionada1(convertedFile);
                        console.log("Imagem convertida para PNG:", convertedFile);
                    },
                    "image/png",
                    1 // Qualidade máxima
                );
            };
        };
        reader.readAsDataURL(file);
    }, []);

    const onDrop2 = useCallback((acceptedFiles) => {
        // Obtém o arquivo recebido
        const file = acceptedFiles[0];
        if (!file) {
            alert("Nenhum arquivo recebido.");
            return;
        }

        // Converte a imagem para PNG usando Canvas
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = img.width;
                canvas.height = img.height;

                // Desenha a imagem no Canvas
                ctx.drawImage(img, 0, 0);

                // Converte o Canvas para PNG
                canvas.toBlob(
                    (blob) => {
                        const convertedFile = new File([blob], `${file.name.split('.')[0]}.png`, { type: "image/png" });
                        setImagemSelecionada2(convertedFile);
                        console.log("Imagem convertida para PNG:", convertedFile);
                    },
                    "image/png",
                    1 // Qualidade máxima
                );
            };
        };
        reader.readAsDataURL(file);
    }, []);

    const onDrop3 = useCallback((acceptedFiles) => {
        // Obtém o arquivo recebido
        const file = acceptedFiles[0];
        if (!file) {
            alert("Nenhum arquivo recebido.");
            return;
        }

        // Converte a imagem para PNG usando Canvas
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = img.width;
                canvas.height = img.height;

                // Desenha a imagem no Canvas
                ctx.drawImage(img, 0, 0);

                // Converte o Canvas para PNG
                canvas.toBlob(
                    (blob) => {
                        const convertedFile = new File([blob], `${file.name.split('.')[0]}.png`, { type: "image/png" });
                        setImagemSelecionada3(convertedFile);
                        console.log("Imagem convertida para PNG:", convertedFile);
                    },
                    "image/png",
                    1 // Qualidade máxima
                );
            };
        };
        reader.readAsDataURL(file);
    }, []);

    const onDrop4 = useCallback((acceptedFiles) => {
        // Obtém o arquivo recebido
        const file = acceptedFiles[0];
        if (!file) {
            alert("Nenhum arquivo recebido.");
            return;
        }

        // Converte a imagem para PNG usando Canvas
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = img.width;
                canvas.height = img.height;

                // Desenha a imagem no Canvas
                ctx.drawImage(img, 0, 0);

                // Converte o Canvas para PNG
                canvas.toBlob(
                    (blob) => {
                        const convertedFile = new File([blob], `${file.name.split('.')[0]}.png`, { type: "image/png" });
                        setImagemSelecionada4(convertedFile);
                        console.log("Imagem convertida para PNG:", convertedFile);
                    },
                    "image/png",
                    1 // Qualidade máxima
                );
            };
        };
        reader.readAsDataURL(file);
    }, []);



    const { getRootProps: getRootProps1, getInputProps: getInputProps1 } = useDropzone({
        onDrop: onDrop1,

        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: 'image/*', // Restringe a aceitação apenas para arquivos .png
    });

    const { getRootProps: getRootProps2, getInputProps: getInputProps2 } = useDropzone({
        onDrop: onDrop2,
        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: 'image/*', // Restringe a aceitação apenas para arquivos .png
    });
    const { getRootProps: getRootProps3, getInputProps: getInputProps3 } = useDropzone({
        onDrop: onDrop3,
        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: 'image/*', // Restringe a aceitação apenas para arquivos .png
    });
    const { getRootProps: getRootProps4, getInputProps: getInputProps4 } = useDropzone({
        onDrop: onDrop4,
        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: 'image/*', // Restringe a aceitação apenas para arquivos .png
    });



    const [videoSelecionado1, setVideoSelecionado1] = useState(null);
    const [videoSelecionado2, setVideoSelecionado2] = useState(null);
    const [videoSelecionado3, setVideoSelecionado3] = useState(null);


    const onDropVideo1 = useCallback((acceptedFiles) => {
        // Valida o tipo de arquivo
        if (!acceptedFiles[0].type.includes('video/mp4')) {
            alert('Apenas arquivos MP4 são permitidos.');
            return;
        }

        // Processa o arquivo PNG
        setVideoSelecionado1(acceptedFiles[0]);

    }, []);

    const onDropVideo2 = useCallback((acceptedFiles) => {
        // Valida o tipo de arquivo
        if (!acceptedFiles[0].type.includes('video/mp4')) {
            alert('Apenas arquivos MP4 são permitidos.');
            return;
        }

        // Processa o arquivo PNG
        setVideoSelecionado2(acceptedFiles[0]);
    }, []);

    const onDropVideo3 = useCallback((acceptedFiles) => {
        // Valida o tipo de arquivo
        if (!acceptedFiles[0].type.includes('video/mp4')) {
            alert('Apenas arquivos MP4 são permitidos.');
            return;
        }

        // Processa o arquivo PNG
        setVideoSelecionado3(acceptedFiles[0]);
    }, []);


    const { getRootProps: getRootVideoProps1, getInputProps: getInputVideoProps1 } = useDropzone({
        onDrop: onDropVideo1,
        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: '.mp4', // Restringe a aceitação apenas para arquivos .png

    });
    const { getRootProps: getRootVideoProps2, getInputProps: getInputVideoProps2 } = useDropzone({
        onDrop: onDropVideo2,
        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: '.mp4', // Restringe a aceitação apenas para arquivos .png

    });
    const { getRootProps: getRootVideoProps3, getInputProps: getInputVideoProps3 } = useDropzone({
        onDrop: onDropVideo3,
        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: '.mp4', // Restringe a aceitação apenas para arquivos .png

    });


    const [arquivoSelecionado1, setArquivoSelecionado1] = useState(null);
    const [arquivoSelecionado2, setArquivoSelecionado2] = useState(null);
    const [arquivoSelecionado3, setArquivoSelecionado3] = useState(null);

    const onDropArquivo1 = useCallback((acceptedFiles) => {
        setArquivoSelecionado1(acceptedFiles[0]);
    }, []);

    const onDropArquivo2 = useCallback((acceptedFiles) => {
        setArquivoSelecionado2(acceptedFiles[0]);
    }, []);

    const onDropArquivo3 = useCallback((acceptedFiles) => {
        setArquivoSelecionado3(acceptedFiles[0]);
    }, []);

    const { getRootProps: getRootArquivoProps1, getInputProps: getInputArquivoProps1 } = useDropzone({
        onDrop: onDropArquivo1,
        multiple: false, // Apenas um arquivo
        // accept removido → aceita qualquer tipo
    });

    const { getRootProps: getRootArquivoProps2, getInputProps: getInputArquivoProps2 } = useDropzone({
        onDrop: onDropArquivo2,
        multiple: false,
    });

    const { getRootProps: getRootArquivoProps3, getInputProps: getInputArquivoProps3 } = useDropzone({
        onDrop: onDropArquivo3,
        multiple: false,
    });

    const [projetos, setProjetos] = useState([]);


    const [projetosPeD, setProjetosPeD] = useState([]);
    const [projetoPeDSelecionado, setProjetoPeDSelecionado] = useState(null);

    const [motivo, setMotivo] = useState('');

    const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);

    const [instalacoes, setInstalacoes] = useState([]);
    const [instalacaoSelecionada, setInstalacaoSelecionada] = useState(null);


    const [colaboradores, setColaboradores] = useState([]);
    const [colaboradorSelecionado, setColaboradorSelecionado] = useState(null);

    const [solicitacoes, setSolicitacoes] = useState([]);
    const [solicitacaoSelecionada, setSolicitacaoSelecionada] = useState(null);

    const [solicitantes, setSolicitantes] = useState([]);
    const [executores, setExecutores] = useState([]);

    const [solicitanteSelecionado, setSolicitanteSelecionado] = useState(null);

    const [executorSelecionado, setExecutorSelecionado] = useState(null);

    const [nivelPrioridade, setNivelPrioridade] = useState(0);

    const [botaoSalvarClickado, setBotaoSalvarClickado] = useState(false);

    const handleChangeNivelPrioridade = (event) => {
        setNivelPrioridade(event.target.value);
    };

    const [autoCad, setAutoCad] = useState(false);

    const location = useLocation();

    const { categoriaCad, projetoCad, propostaCad, itensCad, flagBack, flagPath } = location.state || {};
    const [categoria, setCategoria] = useState(2);
    const [projetoSelecionado, setProjetoSelecionado] = useState(null);
    const [propostaSelecionada, setPropostaSelecionada] = useState(null);

    const [tipoSolicitante, setTipoSolicitante] = useState(0);
    const [tipoExecutor, setTipoExecutor] = useState(0);


    async function listarInformacoesIniciais() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }


            await api.get("/v1/protected/solicitacoes/listartodos", {
                headers: headers
            }).then(function (response) {
                setSolicitacoes(response.data);


                const selectedSolicitacao = response.data.find(solicitacao => solicitacao.id_solicitacao === 7);


                api.get("/v1/protected/user/retornardadosusuario/" + Cookies.get("id_usuario"), {
                    headers: headers
                }).then(function (response) {
                    setLogado(response.data);
                });



                api.get("/v1/protected/colaboradores/listartodos", {
                    headers: headers
                }).then(function (response) {
                    setColaboradores(response.data);
                });


                api.get("/v1/protected/user/listartodos", {
                    headers: headers
                }).then(function (response) {
                    setSolicitantes(response.data)
                    setExecutores(response.data)

                    handleSetCategoria(2);
                    if (parseInt(flagBack, 10) === 11) {
                        // alert("Cadastrar Por Proposta!");
                        setCategoria(0);
                        setProjetos([]);
                        setProjetoSelecionado(projetoCad);
                        setPropostaSelecionada(propostaCad);

                        setLoading(false);
                    }
                    else if (projetoCad) {
                        setAutoCad(true);
                        setCategoria(categoriaCad);
                        setProjetos([]);
                        setProjetoSelecionado(projetoCad);
                        setPropostaSelecionada(propostaCad);

                        setSolicitacaoSelecionada(selectedSolicitacao || null); // Define null se não encontrar o solicitante
                        setDescricao("Elaborar Ordem de Compra de Insumos da Proposta Nº " + propostaCad.id_proposta + " no Projeto Nº " + projetoCad.id_projeto + " da instalação " + returnDescricaoInstalacao(projetoCad.instalacao));


                        setLoading(false);
                    }
                    else {

                        api.get("v1/protected/projetos/listartodos", {
                            headers: headers
                        }).then(function (response) {
                            setProjetos(response.data)

                            api.get("v1/protected/ped/listartodos", {
                                headers: headers
                            }).then(function (response) {
                                setProjetosPeD(response.data);

                                setLoading(false);
                            });
                        });




                    }

                });


            });



        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar Solicitações: " + _err)

        }

    }



    function handleSetSolicitacao(solicitacao) {
        setSolicitacaoSelecionada(solicitacao);

        if (solicitacao.id_solicitacao === 7) {
            setSolicitantesSelecionados([...solicitantesSelecionados, logado]);

        }
    }

    function returnDescricaoEndereco(objeto) {
        var texto = objeto.logradouro + ", " + objeto.numero + ", " + " bairro " +
            objeto.bairro + ", " + objeto.cidade + " UF: " + objeto.estado + " CEP: " + objeto.cep;
        return texto;
    }

    function handleSolicitante(solicitante) {
        setSolicitanteSelecionado(solicitante);
    }

    function handleExecutor(executor) {
        setExecutorSelecionado(executor);
    }



    function handleSetProjeto(projeto) {
        setProjetoSelecionado(projeto);
    }


    function handleSetProposta(proposta) {
        setPropostaSelecionada(proposta);
    }


    function handleSetProjetoPeD(projeto) {
        setProjetoPeDSelecionado(projeto);
    }


    function returnDescricaoColaborador(colaborador) {

        var endereco = returnDescricaoEndereco(colaborador);

        var texto = "Colaborador_ID: " + colaborador.id_colaborador +
            "\nCPF: " + colaborador.cpf +
            "\nNome: " + colaborador.nome + " " + colaborador.sobrenome + "\n " + endereco;
        return texto;
    }



    useEffect(() => {
        listarInformacoesIniciais();


    }, []);


    function returnDescricaoInstalacao(instalacao) {
        var texto = "SIGMA: " + instalacao.identificador_integrador + "\nCPF/CNPJ: " + (instalacao.tipo_instalacao === 0 ? instalacao.cpf : instalacao.cnpj) +
            "\n" + (instalacao.tipo_instalacao === 0 ? (instalacao.nome + " " + instalacao.sobrenome) : instalacao.nome_fantasia);

        return texto;
    }


    function returnDescricaoSolicitacao(solicitacao) {
        var texto = solicitacao.solicitacao;
        return texto;
    }


    const [solicitantesSelecionados, setSolicitantesSelecionados] = useState([]);

    const handleAdicionarSolicitante = (event, newValue) => {
        // Verifica se o valor selecionado já está na lista
        const valoresSelecionados = Array.isArray(newValue) ? newValue : [newValue];
        const novosSolicitantes = valoresSelecionados.filter(
            (opcao) => !solicitantesSelecionados.some((selecionado) => selecionado.id_usuario === opcao.id_usuario)
        );

        setSolicitantesSelecionados([...solicitantesSelecionados, ...novosSolicitantes]);
    };


    const handleRemoverSolicitante = (event, solicitanteRemovido) => {
        const novosSolicitantes = solicitantesSelecionados.filter(
            (solicitante) => solicitante.id_usuario !== solicitanteRemovido.id_usuario
        );
        setSolicitantesSelecionados(novosSolicitantes);
    };



    async function salvar() {

        setBotaoSalvarClickado(true);

        try {


            if (descricao.length < 50) {
                alert("A descrição precisa ter no mínimo 50 caracteres, especifique melhor sua descrição.");
                setBotaoSalvarClickado(false);

                return;
            }


            const formData = new FormData();
            formData.append('usuario_criador.id_usuario', Cookies.get("id_usuario"));
            formData.append('categoria_ordem', categoria);
            formData.append('descricao_solicitacao', descricao);
            formData.append('nivel_prioridade', nivelPrioridade);
            formData.append('tipo_solicitante', tipoSolicitante);
            formData.append('tipo_executor', tipoExecutor);



            if (colaboradorSelecionado) {
                //analista é o proprio usuario
                formData.append('id_colaborador', colaboradorSelecionado.id_colaborador);
            }



            if (autoCad) {
                formData.append('auto_cad', 1);

            }


            if (categoria === 0) {
                if (!projetoSelecionado) {
                    alert("Selecione o Projeto!");
                    setBotaoSalvarClickado(false);
                    return;
                } else {
                    formData.append('projeto_id_cad', projetoSelecionado.id_projeto);
                    if (!propostaSelecionada) {
                        alert("Selecione a Proposta!")
                        setBotaoSalvarClickado(false);
                        return;
                    } else {
                        formData.append('proposta_id_cad', propostaSelecionada.id_proposta);
                    }
                }
            } else if (categoria === 1) {
                if (!projetoPeDSelecionado) {
                    alert("Selecione o Projeto de Pesquisa e Desenvolvimento!");
                    setBotaoSalvarClickado(false);
                    return;
                } else {
                    formData.append('ped_id_cad', projetoPeDSelecionado.id_projeto);
                }
            } else if (categoria === 2) {
                if (!instalacaoSelecionada) {


                } else {
                    formData.append('instalacao.id_instalacao', instalacaoSelecionada.id_instalacao);
                    formData.append('id_instalacao', instalacaoSelecionada.id_instalacao);

                }
            }


            if (!solicitacaoSelecionada) {
                alert("Informe a Solicitação!");
                setBotaoSalvarClickado(false);
                return;
            } else {
                formData.append('solicitacao.id_solicitacao', solicitacaoSelecionada.id_solicitacao);
            }




            if (solicitacaoSelecionada.id_solicitacao !== 7) {
                if (tipoSolicitante === 0) {
                    formData.append('usuario_solicitante.id_usuario', Cookies.get("id_usuario"));
                } else if (tipoSolicitante === 1) {
                    //outro usuairo é o solicitante
                    if (!solicitanteSelecionado.id_usuario) {
                        alert("Informe o Solicitante!");
                        setBotaoSalvarClickado(false);
                        return;
                    } else {
                        formData.append('usuario_solicitante.id_usuario', Cookies.get("id_usuario"));
                    }
                } else if (tipoSolicitante === 2) {
                    //um cliente é um solicitante
                }

            } else {
                if (!solicitantesSelecionados || solicitantesSelecionados.length < 1) {
                    alert("Informe um ou mais solicitantes!");
                    setBotaoSalvarClickado(false);
                    return;
                } else {
                    //cadastro.solicitantes = solicitantesSelecionados;
                }
            }


            /*
            cadastro.auto_cad = 1;
            if (!usuarioSelecionado) {
                alert("Informe o Analista a executar a O.S");
                setBotaoSalvarClickado(false);
                return;
            } else {
                cadastro.analista = { id_usuario: usuarioSelecionado.id_usuario };
                cadastro.motivo = motivo;
            }*/


            if (autoCad) {
                // cadastro.itens_pre_requerimento = itensCad;
                //cadastro.finalizar_requerimento_itens = 1;
            }

            if (tipoExecutor === 20 && !executorSelecionado) {
                alert("Informe o usuário quem deverá executar a Ordem de Serviço");
                setBotaoSalvarClickado(false);
                return;
            } else if (tipoExecutor === 20 && executorSelecionado) {
                //analista é outro usuario
                formData.append('analista.id_usuario', executorSelecionado.id_usuario);
            } else if (tipoExecutor === 10) {
                //analista é o proprio usuario
                formData.append('analista.id_usuario', Cookies.get("id_usuario"));
            }

            console.log("cadastrar chamado");


            formData.append('descricao_imagem1', descricaoImagem1);
            formData.append('descricao_imagem2', descricaoImagem2);
            formData.append('descricao_imagem3', descricaoImagem3);
            formData.append('descricao_imagem4', descricaoImagem4);


            formData.append('descricao_video1', descricaoVideo1);
            formData.append('descricao_video2', descricaoVideo2);
            formData.append('descricao_video3', descricaoVideo3);

            formData.append('descricao_arquivo1', descricaoArquivo1);
            formData.append('descricao_arquivo2', descricaoArquivo2);
            formData.append('descricao_arquivo3', descricaoArquivo3);





            // Adicionar as imagens ao FormData
            formData.append('imagens', imagemSelecionada1);
            formData.append('imagens', imagemSelecionada2);
            formData.append('imagens', imagemSelecionada3);
            formData.append('imagens', imagemSelecionada4);

            formData.append('videos', videoSelecionado1);
            formData.append('videos', videoSelecionado2);
            formData.append('videos', videoSelecionado3);

            formData.append('arquivos', arquivoSelecionado1);
            formData.append('arquivos', arquivoSelecionado2);
            formData.append('arquivos', arquivoSelecionado3);

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.post('/v1/protected/ordemservico/cadastrar', formData,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Ordem de Serviço Cadastrada");

                if (parseInt(flagBack, 10) === 11) {
                    history.push({
                        pathname: flagPath,
                    })
                } else {
                    history.push({
                        pathname: "/gestao/administracao/ordensdeservicos/editar/" + cadastro_salvo.id_ordem_servico,
                    })
                }

            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
                setBotaoSalvarClickado(false);

            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");
            setBotaoSalvarClickado(false);

        }



    }


    function returnDescricaoSolicitante(usuario) {
        var texto = usuario.nome_amigavel;
        return texto;
    }

    function returnDescricaoExecutor(usuario) {
        var texto = usuario.nome_amigavel;
        return texto;
    }


    function returnDescricaoProjeto(projeto) {
        try {
            if (!projeto) return "Projeto não informado";

            const texto =
                (projeto.id_projeto || "") + " - " + (projeto.nome_projeto || "") + "<br>" +
                (projeto.descricao_projeto || "") + "<br>" +
                (projeto.instalacao ? returnDescricaoInstalacao(projeto.instalacao) : "");

            return texto;
        } catch (e) {
            console.error("Erro ao montar descrição do projeto:", e);
            return "Erro ao obter dados do projeto";
        }
    }

    function returnDescricaoProposta(proposta) {
        var texto = proposta.id_proposta + " - " + proposta.descricao_proposta;
        return texto;
    }


    function returnDescricaoProjetoPeD(projeto) {
        var texto = projeto.id_projeto + " - " + projeto.descricao_projeto;
        return texto;
    }


    function returnDescricaoUsuario(usuario) {
        var texto = "ID_Usuario: " + usuario.id_usuario + "\nNome: " + usuario.nome_amigavel + "\nRegiões de Atuação: " + usuario.regiao_cobertura;

        var dados_colaborador = "";

        if (usuario.tipo_associacao === 0) {
            //colaborador
            dados_colaborador += ("\nDepartamentos: " + usuario.colaborador.departamentos.map(departamento => departamento.nome).join(", "));
            dados_colaborador += ("\nCargos: " + usuario.colaborador.cargos.map(cargo => cargo.nome).join(", "));
            dados_colaborador += ("\nFunções: " + usuario.colaborador.funcoes.map(funcao => funcao.nome).join(", "));


        }

        texto += ("\n" + dados_colaborador);


        return texto;
    }

    async function handleSetCategoria(categoria) {

        setCategoria(categoria);
        if (categoria === 2) {
            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            await api.get("v1/protected/clientes/instalacoes/listartodos", {
                headers: headers
            }).then(function (response) {
                setInstalacoes(response.data)
            });
        }

    }


    return (
        <MuiThemeProvider theme={muiTheme}>
            <CoreThemeProvider theme={coreTheme}>
                <div style={{ backgroundColor: themeHelper.bg, minHeight: '100vh', transition: 'background-color 0.3s' }}>
                    <NavegadorGestao
                        ListarOrdemSevicos={'underline'}
                        corGestaoServicosMarcado={'orange'}
                        Gestao={'underline'}
                        corGestaoMarcado={'orange'}
                        corFundo={themeHelper.paper}
                        travado={true}
                        corTexto={themeHelper.text}
                    />

                    {!loading &&

                        <Grid container spacing={3} item xs={12} style={{ padding: '0 10px' }}>
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                align="flex-start"
                                item xs={12}
                                style={{ width: '100%', margin: 0, padding: 0 }}
                            >

                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    align="flex-start"
                                    item xs={12}
                                    style={{ width: '100%', margin: 0, padding: 0 }}
                                >

                                    <a href={"/gestao/administracao/ordensdeservicos/listar"} style={{ fontSize: 14, color: themeHelper.text, marginRight: '5px', paddingTop: 10 }}>{"< Ordens de Serviços | "}</a>
                                    <span style={{ fontSize: 18, color: themeHelper.text, marginRight: '5px', paddingTop: 10 }}>{" Nova Ordem de Serviço"}</span>

                                </Grid>

                                <Grid
                                    item xs={12}
                                    container
                                    direction="row"
                                    alignItems="center"
                                    justifyContent={"center"}
                                >
                                    <Box style={{ backgroundColor: themeHelper.paper, width: '100%' }}>
                                        <AppBar position="static" color="default" sx={{ bgcolor: themeHelper.paper, backgroundImage: 'none', boxShadow: 'none' }}>
                                            <Tabs
                                                value={value}
                                                onChange={handleChangeTab}
                                                indicatorColor="primary"
                                                textColor="primary"
                                                variant="scrollable"
                                                scrollButtons="auto"
                                                style={{ backgroundColor: themeHelper.paper }}
                                            >
                                                <Tab label="Informações Iniciais" style={{ color: themeHelper.text }} />
                                                <Tab label="Imagens" style={{ color: themeHelper.text }} />
                                                <Tab label="Vídeos" style={{ color: themeHelper.text }} />
                                                <Tab label="Documentos" style={{ color: themeHelper.text }} />
                                            </Tabs>
                                        </AppBar>
                                    </Box>
                                </Grid>


                                <SwipeableViews
                                    index={value}
                                    onChangeIndex={handleChangeIndex}
                                    style={{ backgroundColor: themeHelper.paper, width: '100%' }}
                                >
                                    {/* SLIDE 0: Informações Iniciais */}
                                    <Grid item xs={12} container spacing={3} style={{ padding: '30px 10px' }}>
                                        {/* Row 1: Categoria e Solicitação */}
                                        <Grid item xs={12} container spacing={3} style={{ padding: '10px 20px' }}>
                                            <Grid item xs={12} md={4}>
                                                <FormControl fullWidth variant="standard">
                                                    <InputLabel style={{ color: themeHelper.text }}>Categoria</InputLabel>
                                                    <Select
                                                        value={categoria}
                                                        disabled={autoCad}
                                                        onChange={(e) => handleSetCategoria(e.target.value)}
                                                        style={{ color: themeHelper.text }}
                                                        startAdornment={
                                                            <InputAdornment position="start">
                                                                <ListAltIcon style={{ color: themeHelper.text }} />
                                                            </InputAdornment>
                                                        }
                                                    >
                                                        <MenuItem value={0}>Projeto</MenuItem>
                                                        <MenuItem value={1}>Pesquisa & Desenvolvimento</MenuItem>
                                                        <MenuItem value={2}>Serviços e Manutenção</MenuItem>
                                                        <MenuItem value={3}>Renovar Estoque</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={8}>
                                                <Autocomplete
                                                    id="select-solicitacao"
                                                    options={solicitacoes}
                                                    getOptionLabel={(sol) => returnDescricaoSolicitacao(sol).replace(/<br \/>/g, '\n')}
                                                    value={solicitacaoSelecionada}
                                                    onChange={(e, v) => handleSetSolicitacao(v)}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label=" Tipo de Solicitação "
                                                            variant="standard"
                                                            fullWidth
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                startAdornment: (
                                                                    <>
                                                                        <InputAdornment position="start">
                                                                            <ListAltIcon style={{ color: themeHelper.text }} />
                                                                        </InputAdornment>
                                                                        {params.InputProps.startAdornment}
                                                                    </>
                                                                ),
                                                            }}
                                                        />
                                                    )}
                                                    renderOption={(option) => (
                                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoSolicitacao(option) }} />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>

                                        {/* Row 2: Sub-Categoria (Condicional) */}
                                        {categoria === 0 && (
                                            <Grid item xs={12} container spacing={3} style={{ padding: '10px 20px' }}>
                                                <Grid item xs={12} md={6}>
                                                    <Autocomplete
                                                        id="select-projeto"
                                                        options={projetos}
                                                        getOptionLabel={(p) => returnDescricaoProjeto(p).replace(/<br \/>/g, '\n')}
                                                        value={projetoSelecionado}
                                                        onChange={(e, v) => handleSetProjeto(v)}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label=" Projeto "
                                                                variant="standard"
                                                                fullWidth
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    startAdornment: (
                                                                        <>
                                                                            <InputAdornment position="start">
                                                                                <AssignmentIcon style={{ color: themeHelper.text }} />
                                                                            </InputAdornment>
                                                                            {params.InputProps.startAdornment}
                                                                        </>
                                                                    ),
                                                                }}
                                                            />
                                                        )}
                                                        renderOption={(option) => (
                                                            <div dangerouslySetInnerHTML={{ __html: returnDescricaoProjeto(option) }} />
                                                        )}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <Autocomplete
                                                        disabled={!projetoSelecionado}
                                                        options={projetoSelecionado ? projetoSelecionado.propostas : []}
                                                        getOptionLabel={(pr) => returnDescricaoProposta(pr).replace(/<br \/>/g, '\n')}
                                                        value={propostaSelecionada}
                                                        onChange={(e, v) => handleSetProposta(v)}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label=" Proposta "
                                                                variant="standard"
                                                                fullWidth
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    startAdornment: (
                                                                        <>
                                                                            <InputAdornment position="start">
                                                                                <DescriptionIcon style={{ color: themeHelper.text }} />
                                                                            </InputAdornment>
                                                                            {params.InputProps.startAdornment}
                                                                        </>
                                                                    ),
                                                                }}
                                                            />
                                                        )}
                                                        renderOption={(option) => (
                                                            <div dangerouslySetInnerHTML={{ __html: returnDescricaoProposta(option) }} />
                                                        )}
                                                    />
                                                </Grid>
                                            </Grid>
                                        )}
                                        {categoria === 1 && (
                                            <Grid item xs={12} container style={{ padding: '10px 20px' }}>
                                                <Autocomplete
                                                    fullWidth
                                                    options={projetosPeD}
                                                    getOptionLabel={(p) => returnDescricaoProjetoPeD(p).replace(/<br \/>/g, '\n')}
                                                    value={projetoPeDSelecionado}
                                                    onChange={(e, v) => handleSetProjetoPeD(v)}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label=" Projeto de P&D "
                                                            variant="standard"
                                                            fullWidth
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                startAdornment: (
                                                                    <>
                                                                        <InputAdornment position="start">
                                                                            <AssignmentIcon style={{ color: themeHelper.text }} />
                                                                        </InputAdornment>
                                                                        {params.InputProps.startAdornment}
                                                                    </>
                                                                ),
                                                            }}
                                                        />
                                                    )}
                                                    renderOption={(option) => (
                                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoProjetoPeD(option) }} />
                                                    )}
                                                />
                                            </Grid>
                                        )}
                                        {categoria === 2 && (
                                            <Grid item xs={12} container style={{ padding: '10px 20px' }}>
                                                <Autocomplete
                                                    fullWidth
                                                    options={instalacoes}
                                                    getOptionLabel={(i) => returnDescricaoInstalacao(i).replace(/<br \/>/g, '\n')}
                                                    value={instalacaoSelecionada}
                                                    onChange={(e, v) => setInstalacaoSelecionada(v)}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label=" Instalação "
                                                            variant="standard"
                                                            fullWidth
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                startAdornment: (
                                                                    <>
                                                                        <InputAdornment position="start">
                                                                            <BusinessIcon style={{ color: themeHelper.text }} />
                                                                        </InputAdornment>
                                                                        {params.InputProps.startAdornment}
                                                                    </>
                                                                ),
                                                            }}
                                                        />
                                                    )}
                                                    renderOption={(option) => (
                                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoInstalacao(option) }} />
                                                    )}
                                                />
                                            </Grid>
                                        )}

                                        {/* Row 3: Solicitantes */}
                                        <Grid item xs={12} container spacing={3} style={{ padding: '10px 20px' }}>
                                            {(solicitacaoSelecionada && solicitacaoSelecionada.id_solicitacao === 7) ? (
                                                <Grid item xs={12}>
                                                    <Autocomplete
                                                        multiple
                                                        options={solicitantes}
                                                        getOptionLabel={(s) => returnDescricaoSolicitante(s).replace(/<br \/>/g, '\n')}
                                                        value={solicitantesSelecionados}
                                                        onChange={handleAdicionarSolicitante}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label=" Solicitantes (Múltiplos) "
                                                                variant="standard"
                                                                fullWidth
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    startAdornment: (
                                                                        <>
                                                                            <InputAdornment position="start">
                                                                                <PersonIcon style={{ color: themeHelper.text }} />
                                                                            </InputAdornment>
                                                                            {params.InputProps.startAdornment}
                                                                        </>
                                                                    ),
                                                                }}
                                                            />
                                                        )}
                                                        renderTags={(value, getTagProps) =>
                                                            value.map((sol, index) => (
                                                                <Chip label={returnDescricaoSolicitante(sol)} {...getTagProps({ index })} onDelete={(e) => handleRemoverSolicitante(e, sol)} />
                                                            ))
                                                        }
                                                    />
                                                </Grid>
                                            ) : (
                                                <>
                                                    <Grid item xs={12} md={4}>
                                                        <FormControl fullWidth variant="standard">
                                                            <InputLabel style={{ color: themeHelper.text }}>Tipo de Solicitante</InputLabel>
                                                            <Select
                                                                value={tipoSolicitante}
                                                                onChange={(e) => setTipoSolicitante(e.target.value)}
                                                                style={{ color: themeHelper.text }}
                                                                startAdornment={
                                                                    <InputAdornment position="start">
                                                                        <PersonIcon style={{ color: themeHelper.text }} />
                                                                    </InputAdornment>
                                                                }
                                                            >
                                                                <MenuItem value={0}>Sou o solicitante</MenuItem>
                                                                <MenuItem value={10}>Usuário do Sistema</MenuItem>
                                                                <MenuItem value={20}>Cliente</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12} md={8}>
                                                        {tipoSolicitante === 10 && (
                                                            <Autocomplete
                                                                options={solicitantes}
                                                                getOptionLabel={(s) => returnDescricaoSolicitante(s).replace(/<br \/>/g, '\n')}
                                                                value={solicitanteSelecionado}
                                                                onChange={(e, v) => handleSolicitante(v)}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label=" Escolha o Solicitante "
                                                                        variant="standard"
                                                                        fullWidth
                                                                        InputProps={{
                                                                            ...params.InputProps,
                                                                            startAdornment: (
                                                                                <>
                                                                                    <InputAdornment position="start">
                                                                                        <PersonIcon style={{ color: themeHelper.text }} />
                                                                                    </InputAdornment>
                                                                                    {params.InputProps.startAdornment}
                                                                                </>
                                                                            ),
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        )}
                                                    </Grid>
                                                </>
                                            )}
                                        </Grid>

                                        {/* Row 4: Executor e Prioridade */}
                                        <Grid item xs={12} container spacing={3} style={{ padding: '10px 20px' }}>
                                            <Grid item xs={12} md={4}>
                                                <FormControl fullWidth variant="standard">
                                                    <InputLabel style={{ color: themeHelper.text }}>Executor</InputLabel>
                                                    <Select
                                                        value={tipoExecutor}
                                                        onChange={(e) => setTipoExecutor(e.target.value)}
                                                        style={{ color: themeHelper.text }}
                                                        startAdornment={
                                                            <InputAdornment position="start">
                                                                <EngineeringIcon style={{ color: themeHelper.text }} />
                                                            </InputAdornment>
                                                        }
                                                    >
                                                        <MenuItem value={0}>Sistema Designa o Executor</MenuItem>
                                                        <MenuItem value={10}>Sou o Executor</MenuItem>
                                                        <MenuItem value={20}>Usuário do Sistema</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={8}>
                                                {tipoExecutor === 20 && (
                                                    <Autocomplete
                                                        options={executores}
                                                        getOptionLabel={(ex) => returnDescricaoExecutor(ex).replace(/<br \/>/g, '\n')}
                                                        value={executorSelecionado}
                                                        onChange={(e, v) => handleExecutor(v)}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label=" Escolha o Executor "
                                                                variant="standard"
                                                                fullWidth
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    startAdornment: (
                                                                        <>
                                                                            <InputAdornment position="start">
                                                                                <EngineeringIcon style={{ color: themeHelper.text }} />
                                                                            </InputAdornment>
                                                                            {params.InputProps.startAdornment}
                                                                        </>
                                                                    ),
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                )}
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12} container spacing={3} style={{ padding: '20px 20px', marginTop: 10 }}>
                                            <Grid item xs={12} md={4}>
                                                <FormControl fullWidth variant="standard">
                                                    <InputLabel style={{ color: themeHelper.text }}>Prioridade</InputLabel>
                                                    <Select
                                                        value={nivelPrioridade}
                                                        onChange={handleChangeNivelPrioridade}
                                                        style={{ color: themeHelper.text }}
                                                        startAdornment={
                                                            <InputAdornment position="start">
                                                                <PriorityHighIcon style={{ color: themeHelper.text }} />
                                                            </InputAdornment>
                                                        }
                                                    >
                                                        <MenuItem value={0}>Comum (72h) - Nível 0</MenuItem>
                                                        <MenuItem value={1}>Urgente (48h) - Nível 1</MenuItem>
                                                        <MenuItem value={2}>Priorizar (24h) - Nível 2</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={8}>
                                                <TextField
                                                    variant="standard"
                                                    label="Descrição Detalhada / Observações"
                                                    required
                                                    value={descricao}
                                                    onChange={(e) => setDescricao(e.target.value)}
                                                    fullWidth
                                                    multiline
                                                    minRows={2}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <NotesIcon style={{ color: themeHelper.text }} />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', padding: '20px' }}>
                                            <Button variant="contained" color="primary" onClick={salvar} disabled={botaoSalvarClickado} style={{ minWidth: 200 }}>
                                                Salvar Ordem de Serviço
                                            </Button>
                                        </Grid>
                                    </Grid>

                                    {/* SLIDE 1: Imagens */}
                                    <Grid item xs={12} container spacing={3} style={{ padding: '30px 10px' }}>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Card style={{ backgroundColor: themeHelper.paper, color: themeHelper.text }}>
                                                <CardContent>
                                                    {imagemSelecionada1 ? <img src={URL.createObjectURL(imagemSelecionada1)} style={{ width: '100%', borderRadius: 4 }} alt="Img 1" /> : (
                                                        <div {...getRootProps1()} style={{ ...dropzoneStyles, border: `2px dashed ${themeHelper.text}`, padding: 20 }}>
                                                            <input {...getInputProps1()} /><Typography align="center">Imagem 1</Typography>
                                                        </div>
                                                    )}
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        label="Descrição"
                                                        value={descricaoImagem1}
                                                        onChange={(e) => setDescricaoImagem1(e.target.value)}
                                                        style={{ marginTop: 10 }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <NotesIcon style={{ color: themeHelper.text }} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Card style={{ backgroundColor: themeHelper.paper, color: themeHelper.text }}>
                                                <CardContent>
                                                    {imagemSelecionada2 ? <img src={URL.createObjectURL(imagemSelecionada2)} style={{ width: '100%', borderRadius: 4 }} alt="Img 2" /> : (
                                                        <div {...getRootProps2()} style={{ ...dropzoneStyles, border: `2px dashed ${themeHelper.text}`, padding: 20 }}>
                                                            <input {...getInputProps2()} /><Typography align="center">Imagem 2</Typography>
                                                        </div>
                                                    )}
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        label="Descrição"
                                                        value={descricaoImagem2}
                                                        onChange={(e) => setDescricaoImagem2(e.target.value)}
                                                        style={{ marginTop: 10 }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <NotesIcon style={{ color: themeHelper.text }} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Card style={{ backgroundColor: themeHelper.paper, color: themeHelper.text }}>
                                                <CardContent>
                                                    {imagemSelecionada3 ? <img src={URL.createObjectURL(imagemSelecionada3)} style={{ width: '100%', borderRadius: 4 }} alt="Img 3" /> : (
                                                        <div {...getRootProps3()} style={{ ...dropzoneStyles, border: `2px dashed ${themeHelper.text}`, padding: 20 }}>
                                                            <input {...getInputProps3()} /><Typography align="center">Imagem 3</Typography>
                                                        </div>
                                                    )}
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        label="Descrição"
                                                        value={descricaoImagem3}
                                                        onChange={(e) => setDescricaoImagem3(e.target.value)}
                                                        style={{ marginTop: 10 }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <NotesIcon style={{ color: themeHelper.text }} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Card style={{ backgroundColor: themeHelper.paper, color: themeHelper.text }}>
                                                <CardContent>
                                                    {imagemSelecionada4 ? <img src={URL.createObjectURL(imagemSelecionada4)} style={{ width: '100%', borderRadius: 4 }} alt="Img 4" /> : (
                                                        <div {...getRootProps4()} style={{ ...dropzoneStyles, border: `2px dashed ${themeHelper.text}`, padding: 20 }}>
                                                            <input {...getInputProps4()} /><Typography align="center">Imagem 4</Typography>
                                                        </div>
                                                    )}
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        label="Descrição"
                                                        value={descricaoImagem4}
                                                        onChange={(e) => setDescricaoImagem4(e.target.value)}
                                                        style={{ marginTop: 10 }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <NotesIcon style={{ color: themeHelper.text }} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    </Grid>

                                    {/* SLIDE 2: Vídeos */}
                                    <Grid item xs={12} container spacing={3} style={{ padding: '30px 10px' }}>
                                        <Grid item xs={12} md={4}>
                                            <Card style={{ backgroundColor: themeHelper.paper, color: themeHelper.text }}>
                                                <CardContent>
                                                    {videoSelecionado1 ? <video controls src={URL.createObjectURL(videoSelecionado1)} style={{ width: '100%' }} /> : (
                                                        <div {...getRootVideoProps1()} style={{ ...dropzoneStyles, border: `2px dashed ${themeHelper.text}`, padding: 20 }}>
                                                            <input {...getInputVideoProps1()} /><Typography align="center">Vídeo 1</Typography>
                                                        </div>
                                                    )}
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        label="Descrição"
                                                        value={descricaoVideo1}
                                                        onChange={(e) => setDescricaoVideo1(e.target.value)}
                                                        style={{ marginTop: 10 }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <NotesIcon style={{ color: themeHelper.text }} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Card style={{ backgroundColor: themeHelper.paper, color: themeHelper.text }}>
                                                <CardContent>
                                                    {videoSelecionado2 ? <video controls src={URL.createObjectURL(videoSelecionado2)} style={{ width: '100%' }} /> : (
                                                        <div {...getRootVideoProps2()} style={{ ...dropzoneStyles, border: `2px dashed ${themeHelper.text}`, padding: 20 }}>
                                                            <input {...getInputVideoProps2()} /><Typography align="center">Vídeo 2</Typography>
                                                        </div>
                                                    )}
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        label="Descrição"
                                                        value={descricaoVideo2}
                                                        onChange={(e) => setDescricaoVideo2(e.target.value)}
                                                        style={{ marginTop: 10 }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <NotesIcon style={{ color: themeHelper.text }} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Card style={{ backgroundColor: themeHelper.paper, color: themeHelper.text }}>
                                                <CardContent>
                                                    {videoSelecionado3 ? <video controls src={URL.createObjectURL(videoSelecionado3)} style={{ width: '100%' }} /> : (
                                                        <div {...getRootVideoProps3()} style={{ ...dropzoneStyles, border: `2px dashed ${themeHelper.text}`, padding: 20 }}>
                                                            <input {...getInputVideoProps3()} /><Typography align="center">Vídeo 3</Typography>
                                                        </div>
                                                    )}
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        label="Descrição"
                                                        value={descricaoVideo3}
                                                        onChange={(e) => setDescricaoVideo3(e.target.value)}
                                                        style={{ marginTop: 10 }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <NotesIcon style={{ color: themeHelper.text }} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    </Grid>

                                    {/* SLIDE 3: Documentos */}
                                    <Grid item xs={12} container spacing={3} style={{ padding: '30px 10px' }}>
                                        <Grid item xs={12} md={4}>
                                            <Card style={{ backgroundColor: themeHelper.paper, color: themeHelper.text }}>
                                                <CardContent>
                                                    {arquivoSelecionado1 ? <div onClick={() => window.open(URL.createObjectURL(arquivoSelecionado1), '_blank')} style={{ cursor: 'pointer', textAlign: 'center' }}>
                                                        <InsertDriveFileIcon style={{ fontSize: 60, color: themeHelper.text }} /><Typography>Doc 1</Typography>
                                                    </div> : (
                                                        <div {...getRootArquivoProps1()} style={{ ...dropzoneStyles, border: `2px dashed ${themeHelper.text}`, padding: 20 }}>
                                                            <input {...getInputArquivoProps1()} /><Typography align="center">Documento 1</Typography>
                                                        </div>
                                                    )}
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        label="Descrição"
                                                        value={descricaoArquivo1}
                                                        onChange={(e) => setDescricaoArquivo1(e.target.value)}
                                                        style={{ marginTop: 10 }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <NotesIcon style={{ color: themeHelper.text }} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Card style={{ backgroundColor: themeHelper.paper, color: themeHelper.text }}>
                                                <CardContent>
                                                    {arquivoSelecionado2 ? <div onClick={() => window.open(URL.createObjectURL(arquivoSelecionado2), '_blank')} style={{ cursor: 'pointer', textAlign: 'center' }}>
                                                        <InsertDriveFileIcon style={{ fontSize: 60, color: themeHelper.text }} /><Typography>Doc 2</Typography>
                                                    </div> : (
                                                        <div {...getRootArquivoProps2()} style={{ ...dropzoneStyles, border: `2px dashed ${themeHelper.text}`, padding: 20 }}>
                                                            <input {...getInputArquivoProps2()} /><Typography align="center">Documento 2</Typography>
                                                        </div>
                                                    )}
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        label="Descrição"
                                                        value={descricaoArquivo2}
                                                        onChange={(e) => setDescricaoArquivo2(e.target.value)}
                                                        style={{ marginTop: 10 }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <NotesIcon style={{ color: themeHelper.text }} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Card style={{ backgroundColor: themeHelper.paper, color: themeHelper.text }}>
                                                <CardContent>
                                                    {arquivoSelecionado3 ? <div onClick={() => window.open(URL.createObjectURL(arquivoSelecionado3), '_blank')} style={{ cursor: 'pointer', textAlign: 'center' }}>
                                                        <InsertDriveFileIcon style={{ fontSize: 60, color: themeHelper.text }} /><Typography>Doc 3</Typography>
                                                    </div> : (
                                                        <div {...getRootArquivoProps3()} style={{ ...dropzoneStyles, border: `2px dashed ${themeHelper.text}`, padding: 20 }}>
                                                            <input {...getInputArquivoProps3()} /><Typography align="center">Documento 3</Typography>
                                                        </div>
                                                    )}
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        label="Descrição"
                                                        value={descricaoArquivo3}
                                                        onChange={(e) => setDescricaoArquivo3(e.target.value)}
                                                        style={{ marginTop: 10 }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <NotesIcon style={{ color: themeHelper.text }} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                </SwipeableViews>
                            </Grid>
                        </Grid>
                    }
                </div>
            </CoreThemeProvider>
        </MuiThemeProvider>
    );
}


